import { z } from "zod";

import { AtomIdSchema, IsoTimestampSchema } from "./common.js";

export const AtomKindSchema = z.enum([
  "problem",
  "goal",
  "constraint",
  "path",
  "tool",
  "finding",
  "proof",
]);
export type AtomKind = z.infer<typeof AtomKindSchema>;

export const AtomStatusSchema = z.enum([
  "active",
  "selected",
  "resolved",
  "rejected",
  "archived",
]);
export type AtomStatus = z.infer<typeof AtomStatusSchema>;

export const AtomRecordSchema = z.object({
  body: z.string(),
  createdAt: IsoTimestampSchema,
  id: AtomIdSchema,
  kind: AtomKindSchema,
  status: AtomStatusSchema,
  tags: z.array(z.string()),
  title: z.string(),
  updatedAt: IsoTimestampSchema,
});
export type AtomRecord = z.infer<typeof AtomRecordSchema>;
